import React from 'react'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import CustomAccordion from '../../../CustomAccordion/CustomAccordion';

import "./HandDominance.scss"

const HandDominance = ({
  formData,
  arrayIndex,
  onChangeHandler,
  onRemoveHandler,
  study,
  showToggleButtons = false,
  filterType = 'include',
  onFilterTypeChange = () => {},
  activeKey,
  onAccordionChange = () => {},
  closeFromBottom = false
}) => {
  const handleAccordionToggle = () => {
    onAccordionChange('handDominance');
  };

  return (
    <CustomAccordion
      title="Hand Dominance"
      previewData={formData}
      showToggleButtons={showToggleButtons}
      filterType={filterType}
      onFilterTypeChange={onFilterTypeChange}
      onRemove={() => onRemoveHandler(arrayIndex)}
      category="hand-dominance"
      isOpen={activeKey === 'handDominance'}
      onToggle={handleAccordionToggle}
      closeFromBottom={closeFromBottom}
    >
      <Form>
        <Row>
          <Col>
            <Form.Label>Is the injured {study === "elbow"? "elbow" : "shoulder"} on the dominant hand side?</Form.Label>
            <Form.Select
              value={formData.handDominance}
              onChange={(e) => {onChangeHandler(arrayIndex, "handDominance", e.target.value)}}
            >
              <option value="" hidden>Select an option</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </Form.Select>
          </Col>
        </Row>
      </Form>
    </CustomAccordion>
  )
}

export default HandDominance